import React from 'react'
import USTemplateDefault from 'src/components/template/us'
// import { useDispatch } from 'react-redux'
// import { updateParams } from 'src/modules/reducers/params'
import styled from 'styled-components'
import { promoCodes } from 'src/constants/promoCodes'
import { useCtaText } from 'src/modules/hooks/useCtaText'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'

export default (props) => {
  // const dispatch = useDispatch()

  // const params = {
  //   irad: '366904',
  //   irmp: '365718',
  // }

  // useEffect(() => {
  //   dispatch(updateParams(params))
  // }, [])
  const ctaCopy = useCtaText({ lang: 'en', market: 'us', disableFreeTrial: false })

  return (
    <StyledContainer>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        offerCode={promoCodes.optimum_pro_plan}
        offerBanner={{
          title: [
            'Optimum discount applied!',
            'Optimum customers get 30% off your first two months',
          ],
        }}
        title={commonTitleText.streamLiveTVSports}
        subtitle={commonSubtitleText.onAnyDevice}
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-optimum.png?ch=width&auto=format,compress"
        networkSubtitle={'Cancel online anytime.'}
        hasOptimumPlanCards={true}
        removeCable={true}
        networkSet="baseball"
        customNetworks={['sportsnetpittsburgh', 'fox', 'espn', 'fs1', 'nflnetwork', 'cbs', 'espn2']}
        showRSN={true}
        ctaText={ctaCopy}
        noIndex={true}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
